import React from "react";

const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) return null;

    const value = payload[0].payload.CARR * 1000;
    const currentCarr = payload[0].value * 1000000;
    const yoyGrowth = payload[1].value;

    const isExistingCarr =
        payload[0].payload.name === "Final" || payload[0].payload.name === "Existing";

    return (
        <div style={{ backgroundColor: "#fff", border: "1px solid #ccc", padding: 10 }}>
            <p className="font-bold">{label}</p>
            <p style={{ color: "#156082" }}>{`Total CARR: $${currentCarr.toLocaleString()}`}</p>
            <p style={{ color: "#156082" }}>{`YoY Growth: ${yoyGrowth}%`}</p>
            {/* <p style={{ color: '#156082' }}>{JSON.stringify(payload)}</p> */}
        </div>
    );
};

export default CustomTooltip;
